import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pass",
  "use": "icon-pass-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-pass\"><g><circle cx=\"14\" cy=\"14\" r=\"14\" /><path stroke=\"#FFF\" stroke-width=\"2\" d=\"M22.43 9.432l-10.42 10.42-6.147-6.147\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol